"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const zxcvbn = require("zxcvbn");
const button_1 = require("../button");
const input_1 = require("../input");
const phone_input_1 = require("../phone-input");
const theme_1 = require("../theme");
const signup_styled_1 = require("./signup.styled");
const pendingUrl = require("./pending.svg");
const successUrl = require("./success.svg");
var PasswordStrength;
(function (PasswordStrength) {
    PasswordStrength["WEAK"] = "weak";
    PasswordStrength["FAIR"] = "fair";
    PasswordStrength["GOOD"] = "good";
    PasswordStrength["STRONG"] = "strong";
})(PasswordStrength = exports.PasswordStrength || (exports.PasswordStrength = {}));
const passMeter = (password = '') => {
    switch (password && password.length && zxcvbn(password).score) {
        case 2:
            return PasswordStrength.FAIR;
        case 3:
            return PasswordStrength.GOOD;
        case 4:
            return PasswordStrength.STRONG;
        default:
            return PasswordStrength.WEAK;
    }
};
const passwordCheck = (input = '') => {
    return {
        length: input && input.length > 7,
        strength: input && input.length && zxcvbn(input).score > 2
    };
};
const BlueButton = theme_1.default.presetTheme(button_1.default, {
    color: 'white',
    bgColor: theme_1.default.colours.primary.default,
    hoverColor: theme_1.default.colours.primary.dark,
    activeColor: theme_1.default.colours.primary.dark
});
const internalValidate = (passwordValue, phoneValue, dialCode) => {
    const phonePrefix = '+' + dialCode;
    let password = '';
    let phone = '';
    if (!phoneValue || !(phoneValue.replace(phonePrefix, ''))) {
        phone = 'Please enter a phone number';
    }
    else if (phoneValue.indexOf(phonePrefix) !== 0) {
        phone = 'Please enter a valid country code';
    }
    if (!passwordValue) {
        password = 'Please enter a password';
    }
    return { phone, password };
};
exports.Signup = ({ phone: inPhone, password: inPass, validate, onSubmit, loading, children }) => {
    const [phone, setPhone] = React.useState(inPhone || '');
    const [password, setPassword] = React.useState(inPass || '');
    const [dialCode, setDialCode] = React.useState('');
    const [liveValidate, setLiveValidate] = React.useState(false);
    const [passwordShow, setPasswordShow] = React.useState(false);
    const internalValidation = internalValidate(password, phone, dialCode);
    const externalValidation = validate ? validate({ phone, password }) : internalValidation;
    const validation = {
        phone: externalValidation.phone || internalValidation.phone,
        password: externalValidation.password || internalValidation.password
    };
    const check = passwordCheck(password);
    const passwordStrength = passMeter(password);
    return React.createElement(signup_styled_1.default, null,
        React.createElement("form", { className: "signup", onSubmit: (e) => {
                e.preventDefault();
                setLiveValidate(true);
                if (!internalValidation.phone && !internalValidation.password) {
                    onSubmit({ phone, password });
                }
            } },
            React.createElement("div", { className: "signup__row" },
                React.createElement("label", { className: "signup__label", htmlFor: "password" }, "Password"),
                React.createElement("div", { className: "signup__password-entry-row" },
                    React.createElement(input_1.default, { className: "signup__password-field", invalid: liveValidate ? !!validation.password : false, required: true, type: !passwordShow ? 'password' : 'text', id: "password", value: password, onChange: (e) => setPassword(e.target.value) }),
                    React.createElement("a", { className: "signup__password-show-hide", href: "#", onClick: (e) => {
                            e.preventDefault();
                            setPasswordShow(!passwordShow);
                        } }, !passwordShow ? 'Show' : 'Hide')),
                liveValidate && validation.password && React.createElement("span", { className: "signup__error" }, validation.password),
                React.createElement("div", { className: "signup__password-validity" },
                    React.createElement("p", { className: "signup__password-validity-label" }, "Make sure your password contains:"),
                    React.createElement("ul", { className: "signup__password-rules" },
                        React.createElement("li", { className: `signup__password-rule` },
                            React.createElement("img", { className: "signup__password-rule-indicator", src: !check.length ? pendingUrl : successUrl }),
                            "At least 8 characters."),
                        React.createElement("li", { className: `signup__password-rule` },
                            React.createElement("img", { className: "signup__password-rule-indicator", src: [PasswordStrength.GOOD, PasswordStrength.STRONG].includes(passwordStrength) ? successUrl : pendingUrl }),
                            "Your password is ",
                            passwordStrength,
                            ".")))),
            React.createElement("div", { className: "signup__row" },
                React.createElement("label", { className: "signup__label", htmlFor: "phone" }, "Phone number"),
                React.createElement(phone_input_1.default, { invalid: liveValidate ? !!validation.phone : false, required: true, type: "tel", id: "phone", value: phone, onChange: (e) => {
                        setPhone(e.value);
                        setDialCode(e.dialCode);
                    } }),
                liveValidate && validation.phone && React.createElement("span", { className: "signup__error" }, validation.phone)),
            React.createElement("div", { className: "signup__button" },
                React.createElement(BlueButton, { loading: loading }, "Sign up for free")),
            children && React.createElement("div", { className: "signup__children" }, children)));
};
//# sourceMappingURL=Signup.js.map